import { render, staticRenderFns } from "./ResultFormAi.vue?vue&type=template&id=79a11b40&scoped=true&"
import script from "./ResultFormAi.vue?vue&type=script&lang=js&"
export * from "./ResultFormAi.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormAi.vue?vue&type=style&index=0&id=79a11b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a11b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a11b40')) {
      api.createRecord('79a11b40', component.options)
    } else {
      api.reload('79a11b40', component.options)
    }
    module.hot.accept("./ResultFormAi.vue?vue&type=template&id=79a11b40&scoped=true&", function () {
      api.rerender('79a11b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ResultFormAi.vue"
export default component.exports